import React from "react"
import { graphql, useStaticQuery, navigate } from "gatsby"
import { Container, CustomLink, Icon } from "@/components"
import cls from "classnames"
import t from "@/constants/wording"
import * as styles from "./index.module.scss"

const OnlineEducation = () => {
  const data = useStaticQuery<AllStrapiEducationCourses>(graphql`
    query FetchEducations {
      allStrapiEducationCourses(limit: 4, sort: { fields: order, order: ASC }) {
        edges {
          node {
            id
            order
            image {
              alt
              media {
                url
              }
            }
            title
            description
            link
          }
        }
      }
    }
  `)

  const {
    allStrapiEducationCourses: { edges },
  } = data
  return (
    <div className={styles.container}>
      <Container>
        <h1 className={cls(styles.h1, styles.title)}>
          {t("Recommended courses")}
        </h1>
        <ul className={cls(styles.educations, "columns is-variable is-4")}>
          {edges.map(({ node }) => (
            <li
              className={cls(
                styles.education,
                "column is-one-quarter-desktop is-half-tablet is-full-mobile"
              )}
              key={node.id}
              onClick={() => node.link && navigate(node.link)}
            >
              <div className={styles.cardContent}>
                <header
                  className={cls(styles.imageContainer, "image is-16by9")}
                >
                  <img src={node.image.media.url} alt={node.image.alt} />
                </header>
                <h4 className={cls(styles.h4)}>{node.title}</h4>
                <p className={styles.p1}>{node.description}</p>
              </div>
            </li>
          ))}
        </ul>
        <div className={styles.more}>
          <CustomLink linkTo={"/courses-catalog"}>
            {t("More education")}
            <Icon name="arrow-right" />
          </CustomLink>
        </div>
      </Container>
    </div>
  )
}

export default OnlineEducation
